module.exports = __webpack_public_path__ + "static/media/noAvSelected.1abe0614.svg";